import posthog from 'posthog-js';
import { useUserStore } from '@store/user';

export function usePosthog() {
    const apiKey = import.meta.env.VITE_POSTHOG_API_KEY;

    if (!apiKey) {
        console.log('PostHog: no API key configured, skipping init');
        return;
    }

    posthog.init(apiKey, {
        api_host: 'https://us.i.posthog.com',
        defaults: '2026-01-30',
        session_recording: {
            maskTextSelector: '.posthog-sensitive',
            maskAllInputs: true,
            maskInputFn: (text, element) => {
                if (element?.classList?.contains('posthog-sensitive')) {
                    // Censor if element has "posthog-sensitive" class
                    return '*'.repeat(text.length);
                }
                // Otherwise, display as is
                return text;
            },
        },
    });

    const userStore = useUserStore();

    watch(
        () => userStore.data?.id,
        (userId) => {
            if (userId) {
                const currentTenant = userStore.data?.tenants?.find((t) => t.id === parseInt(userStore.tenantId));
                posthog.identify(String(userId), {
                    email: userStore.data.email,
                    name: userStore.data.fullname,
                    tenant_id: userStore.tenantId,
                    tenant_name: currentTenant?.name,
                });
            } else {
                posthog.reset();
            }
        },
        { immediate: true },
    );

    return posthog;
}
